export default ({ item_name = null }) => ({
  itemDescription: item_name,
  reasonPath: [],
  lastEnabledSection: null,
});
